import React from "react";
import SettingComponent from "../components/Setting";

const Setting = () => {
  return <SettingComponent />;
};

export default Setting;
